var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1126",
    "data-name": "Group 1126",
    transform: "translate(-1619 -115)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_489",
    "data-name": "Ellipse 489",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(1619 115)",
    fill: "#ff5e4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_46_",
    d: "M35.087,28.811a1.664,1.664,0,0,0-.619-.6h0A1.7,1.7,0,0,0,33.657,28H15.707a1.538,1.538,0,0,0-.811.214h0a1.609,1.609,0,0,0-.619.576,1.509,1.509,0,0,0-.278.918V41.66a1.73,1.73,0,0,0,.235.875,1.606,1.606,0,0,0,.6.6,1.73,1.73,0,0,0,.875.235H33.635a1.73,1.73,0,0,0,.875-.235,1.606,1.606,0,0,0,.6-.6,1.73,1.73,0,0,0,.235-.875V29.708A1.578,1.578,0,0,0,35.087,28.811Zm-1.449.043H33.7l-7.814,6.83a1.666,1.666,0,0,1-2.049.021l-8.154-6.851Zm-4.356,7.854-.6.6,5.165,5.165a.758.758,0,0,1-.214.043H15.708a.351.351,0,0,1-.214-.043l5.186-5.165-.6-.6L14.9,41.873a.351.351,0,0,1-.043-.214V29.708a1.006,1.006,0,0,1,.085-.362l8.366,7.022a2.543,2.543,0,0,0,1.58.6,2.471,2.471,0,0,0,1.58-.64l7.961-6.958a.885.885,0,0,1,.064.342V41.66a.351.351,0,0,1-.043.214Z",
    transform: "translate(1614.329 99.316)",
    fill: "#1a1a1a",
    stroke: "#1a1a1a",
    strokeWidth: 0.25
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail-icon.2495539703afb44bfae971a0b7b64244.svg";
export { ForwardRef as ReactComponent };